import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2924c3df")

_pushScopeId("data-v-2924c3df")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Live Classes")
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = {
  class: "text-sm",
  style: {"font-size":"100%"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Join class")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Browse Classes")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_navbar)
        ]),
        _: 1
      }),
      (!_ctx.classesLoading)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            fullscreen: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_ion_grid, null, {
                  default: _withId(() => [
                    (_ctx.content.liveClasses.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_2, [
                          _createVNode(_component_ion_row, { class: "web-only" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, {
                            class: "web-only row-border",
                            style: {"padding-bottom":"20px","margin-bottom":"10px"}
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.content.liveClasses, (liveClass, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "4",
                                  key: index + liveClass.name
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_card, {
                                      class: "live-class-card",
                                      style: {
										'background-image':
											'url(' + liveClass.trainerData.imgURL + ')',
									}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_grid, null, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_row, null, {
                                              default: _withId(() => [
                                                _createVNode(_component_ion_col, null, {
                                                  default: _withId(() => [
                                                    _createVNode("span", _hoisted_4, _toDisplayString(new Date(
														liveClass.date.seconds * 1000
													).toLocaleString()), 1),
                                                    _hoisted_5,
                                                    _createVNode("span", _hoisted_6, [
                                                      _createVNode("strong", null, _toDisplayString(liveClass.name), 1)
                                                    ]),
                                                    _hoisted_7,
                                                    _createVNode("span", _hoisted_8, _toDisplayString(liveClass.trainerData.name), 1),
                                                    _hoisted_9,
                                                    _hoisted_10,
                                                    _createVNode(_component_ion_button, {
                                                      color: "primary",
                                                      size: "small",
                                                      style: {"margin":"0"},
                                                      onClick: ($event: any) => (_ctx.openModal(liveClass))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createVNode(_component_ion_icon, { icon: _ctx.playCircleOutline }, null, 8, ["icon"]),
                                                        _hoisted_11
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["style"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.content.categories, (category, index) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            size: "12",
                            "size-lg": "3",
                            "size-md": "4",
                            "size-sm": "12",
                            key: category.name + index
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_card, {
                                button: "",
                                onClick: () => _ctx.pullClasses(category?.name),
                                class: "category-cards",
                                style: {
									'background-image': 'url(' + category?.imgURL + ')',
								}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { class: "text-bold text-secondary" }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(category?.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "style"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_content, {
            key: 1,
            fullscreen: true,
            class: "ion-text-center"
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_spinner, {
                class: "spinner",
                name: "crescent"
              })
            ]),
            _: 1
          })),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})